export class Quiz {
    private _options: QuizQuestion[];
    private _answers: QuizAnswer;
    private _index: number;

    public question: QuizQuestion;

    public get count(): number {
        return this._options.length;
    }

    public get current(): number {
        return this._index;
    }

    public get ended(): boolean {
        return this.question === undefined;
    }

    constructor() {
        this.initOptions();
        this._answers = new QuizAnswer();
        this._index = 0;
        this.nextQuestion()
    }

    public answer(answer: QuizOption) {
        this._answers.add(answer.value);
        this.nextQuestion();
    }

    public nextQuestion() {
        this.question = this._options[this._index++];
    }

    public getResults() {
        return this._answers.getResults();
    }

    private initOptions() {
        this._options = [
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretem, ha elismerésben részesítenek.', value: LoveLanguage.AFFIRMATION}),
                b: QuizOption.from({text: 'Szeretem, ha megölelnek.', value: LoveLanguage.TOUCH})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretek kettesben lenni azzal, aki fontos a számomra.', value: LoveLanguage.TIME}),
                b: QuizOption.from({text: 'Amikor segítséget kapok valakitől, érzem, hogy szeret.', value: LoveLanguage.ACTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretek ajándékot kapni.', value: LoveLanguage.GIFTS}),
                b: QuizOption.from({text: 'Szeretek találkozni a barátaimmal.', value: LoveLanguage.TIME})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Akkor érzem, hogy valaki szeret, amikor segít nekem valamiben.', value: LoveLanguage.ACTS}),
                b: QuizOption.from({text: 'Akkor érzem, hogy valaki szeret, amikor megérint.', value: LoveLanguage.TOUCH})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Ha egy barátom átölel, érzem, hogy szeret.', value: LoveLanguage.TOUCH}),
                b: QuizOption.from({text: 'Ha egy barátomtól ajándékot kapok, érzem, hogy szeret.', value: LoveLanguage.GIFTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretek közös programot csinálni a barátaimmal.', value: LoveLanguage.TIME}),
                b: QuizOption.from({text: 'Szeretem megérinteni azokat az embereket, akik fontosak a számomra.', value: LoveLanguage.TOUCH})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'A szeretet látható jelképe (az ajándékok) sokat jelentenek nekem.', value: LoveLanguage.GIFTS}),
                b: QuizOption.from({text: 'Az elismerő szavak, a dicséret szeretet közvetítenek számomra.', value: LoveLanguage.AFFIRMATION})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretem a fizikai közelségét érezni azoknak, akik fontosak számomra.', value: LoveLanguage.TOUCH}),
                b: QuizOption.from({text: 'Szeretem, ha megdicsérik a külsőmet.', value: LoveLanguage.AFFIRMATION})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretek együtt időzni a barátaimmal és a számomra fontos személyekkel.', value: LoveLanguage.TIME}),
                b: QuizOption.from({text: 'Szeretek ajándékot kapni a barátaimtól.', value: LoveLanguage.GIFTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Az elfogadást kifejező szavak nagyon fontasak a számomra.', value: LoveLanguage.AFFIRMATION}),
                b: QuizOption.from({text: 'Ha valaki segít nekem, tudom, hogy szeret.', value: LoveLanguage.ACTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretek közös tevékenységekben részt venni a barátaimmal és a számomra fontos emberekkel.', value: LoveLanguage.TIME}),
                b: QuizOption.from({text: 'Szeretem, ha kedves szavakat mondanak nekem.', value: LoveLanguage.AFFIRMATION})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Jobban hat rám, amit valaki tesz, mint amit mond.', value: LoveLanguage.ACTS}),
                b: QuizOption.from({text: 'Az ölelés összetartozást és megbecsülést fejez ki számmomra.', value: LoveLanguage.TOUCH})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Értékelem a dicséretet, és kerülöm a kritikát.', value: LoveLanguage.AFFIRMATION}),
                b: QuizOption.from({text: 'Sok kisebb ajándék többet jelent számomra, mint egy nagyobb.', value: LoveLanguage.GIFTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Akkor érzem közel magamat másokhoz, amikor beszélgetünk, vagy együtt csinálunk valamit.', value: LoveLanguage.TIME}),
                b: QuizOption.from({text: 'Közelebb érzem magam a barátaimhoz, ha gyakran megérintenek.', value: LoveLanguage.TOUCH})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretem, ha megdicsérnek valamiért, amit tettem, vagy elértem.', value: LoveLanguage.AFFIRMATION}),
                b: QuizOption.from({text: 'Ha valaki megtesz a kedvemért olyasmit, amit nem nagyon kedvel, tudom, hogy szeret.', value: LoveLanguage.ACTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretem, ha a barátaim és a hozzám közel álló emberek megérintenek.', value: LoveLanguage.TOUCH}),
                b: QuizOption.from({text: 'Szeretem, amikor valaki őszinte érdeklődéssel hallgatja, amit mondok.', value: LoveLanguage.TIME})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Amikor valaki segít elvégezni egy feladatot, érzem, hogy szeret.', value: LoveLanguage.ACTS}),
                b: QuizOption.from({text: 'Nagyon örülök, amikor ajándékot kapok.', value: LoveLanguage.GIFTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretem, ha megdicsérik a külsőmet.', value: LoveLanguage.AFFIRMATION}),
                b: QuizOption.from({text: 'Ha valaki időt szán arra, hogy megértse az érzéseimet, érzem, hogy szeret.', value: LoveLanguage.TIME})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Biztonságban érzem magam, amikor egy számomra fontos személy megérint.', value: LoveLanguage.TOUCH}),
                b: QuizOption.from({text: 'A szívességek szeretet fejeznek ki számomra.', value: LoveLanguage.ACTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Nagyra értékelem, ha valaki megetesz értem valamit.', value: LoveLanguage.ACTS}),
                b: QuizOption.from({text: 'Szeretek olyan ajándékot kapni, amit valaki saját kezűleg készít nekem.', value: LoveLanguage.GIFTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Nagyon jól érzem magam, amikor valaki teljes figyelmével felém fordul.', value: LoveLanguage.TIME}),
                b: QuizOption.from({text: 'Nagyon jól érzem magam, maikor valaki szívességet tesz nekem.', value: LoveLanguage.ACTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Ha valaki megajándékoz a születésnapomon, érzem, hogy szeret.', value: LoveLanguage.GIFTS}),
                b: QuizOption.from({text: 'Ha valaki személyes szavakkal köszönt fel a születésnapomon, érzem, hogy szeret.', value: LoveLanguage.AFFIRMATION})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Ha valakitől ajándékot kapok, tudom, hogy gondol rám.', value: LoveLanguage.GIFTS}),
                b: QuizOption.from({text: 'Ha valaki segít a feladataim elvégzésében, érzem, hogy szeret.', value: LoveLanguage.ACTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Nagyra értékelem, ha valaki türelmesen meghallgat, és nem szakít félbe.', value: LoveLanguage.TIME}),
                b: QuizOption.from({text: 'Nagyra értékelem, ha valaki ajándékkal emlékezik meg a különleges napokról.', value: LoveLanguage.GIFTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretem, ha a számomra fontos emberek törődnek azzal, hogy segítsenek a feladataim elvégzésében.', value: LoveLanguage.ACTS}),
                b: QuizOption.from({text: 'Szeretem a hosszú kirándulásokat a barátaim társaságában.', value: LoveLanguage.TIME})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretem átölelni és megpuszilni a barátaimat, és örülök, ha ők is átölelnek és puszit adnak.', value: LoveLanguage.TOUCH}),
                b: QuizOption.from({text: 'Örülök, ha minden különösebb ok nélkül ajándékkal lepnek meg.', value: LoveLanguage.GIFTS})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Szeretem, ha valaki kifejezi a megbecsülését irántam.', value: LoveLanguage.AFFIRMATION}),
                b: QuizOption.from({text: 'Szeretem, ha végig rám néz az, akivel beszélgetek.', value: LoveLanguage.TIME})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Nagy jelentőséget tulajdonítok azoknak az ajándékoknak, amelyeket a barátaimtól kapok.', value: LoveLanguage.GIFTS}),
                b: QuizOption.from({text: 'Jó érzés, ha egy barátom, vagy valaki, akit szeretek, megérint.', value: LoveLanguage.TOUCH})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Amikor valaki szívesen teljesíti a kérésemet, érzem, hogy szeret.', value: LoveLanguage.ACTS}),
                b: QuizOption.from({text: 'Ha valaki elmondja nekem, hogy nagyra becsül, érzem, hogy szeret.', value: LoveLanguage.AFFIRMATION})
            }),
            QuizQuestion.from({
                a: QuizOption.from({text: 'Minden nap szükségem van arra, hogy megérintsenek.', value: LoveLanguage.TOUCH}),
                b: QuizOption.from({text: 'Minden nap szükségem van arra, hogy megdicsérjenek.', value: LoveLanguage.AFFIRMATION})
            })
        ];
    }
}

export interface IQuizAnswer {
    affirmation: number;
    gifts: number;
    time: number;
    acts: number;
    touch: number;
}

export class QuizAnswer {
    private affirmation: number = 0;
    private gifts: number = 0;
    private time: number = 0;
    private acts: number = 0;
    private touch: number = 0;

    add(type: TLoveLanguage) {
        this.hasOwnProperty(type) && this[type]++;
    }

    getResults() {
        const sorted = this.getSortedResults();
        const primaries = [sorted.shift()];
        while (sorted.length && sorted[0].value === primaries[0].value) {
            primaries.push(sorted.shift());
        }
        const secondaries = [];
        if (sorted.length && primaries.length < 3) {
            secondaries.push(sorted.shift());
            while (sorted.length && sorted[0].value === secondaries[0].value) {
                secondaries.push(sorted.shift());
            }
        }
        return {
            primaries: primaries,
            secondaries: secondaries,
            others: sorted
        };
    }

    private getSortedResults() {
        return [
            {type: LoveLanguage.AFFIRMATION, value: this.affirmation},
            {type: LoveLanguage.GIFTS, value: this.gifts},
            {type: LoveLanguage.TIME, value: this.time},
            {type: LoveLanguage.ACTS, value: this.acts},
            {type: LoveLanguage.TOUCH, value: this.touch}
        ].sort((a,b) => b.value - a.value);
    }
}

export interface IQuizQuestion {
    a: QuizOption;
    b: QuizOption;
}

export class QuizQuestion implements IQuizQuestion {
    public a: QuizOption;
    public b: QuizOption;

    constructor(a?: QuizOption, b?: QuizOption) {
        this.a = a;
        this.b = b;
    }

    public static from(obj: IQuizQuestion) {
        return new QuizQuestion(obj.a, obj.b);
    }
}

export interface IQuizOption {
    text: string;
    value: TLoveLanguage;
}

export class QuizOption implements IQuizOption {
    public text: string;
    public value: TLoveLanguage;

    constructor(text?: string, value?: TLoveLanguage) {
        this.text = text;
        this.value = value;
    }

    public static from(obj: IQuizOption) {
        return new QuizOption(obj.text, obj.value);
    }
}

export type TLoveLanguage = 'affirmation'|'gifts'|'time'|'acts'|'touch';

export class LoveLanguage {
    public static AFFIRMATION: TLoveLanguage = 'affirmation';
    public static GIFTS: TLoveLanguage = 'gifts';
    public static TIME: TLoveLanguage = 'time';
    public static ACTS: TLoveLanguage = 'acts';
    public static TOUCH: TLoveLanguage = 'touch';

    constructor() {
        throw new Error();
    }
}



// WEBPACK FOOTER //
// ./src/app/quiz.ts